export enum RoutePath {
  LOGIN = 'login',
  RESET_PASSWORD = 'reset-password',
  ASSESSEES_SEARCH = 'assessees-search',
  ASSESSEES_TABLE = 'assessees-table',
  SET_PASSWORD = 'set-password',
}
